var _style, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stroke",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#252525;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "StrokeThree",
    className: "st0",
    x1: 5.53,
    y1: 27,
    x2: 26.5,
    y2: 27
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "StrokeTwo",
    className: "st0",
    x1: 5.53,
    y1: 16,
    x2: 26.5,
    y2: 16
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "StrokeOne",
    className: "st0",
    x1: 5.53,
    y1: 5,
    x2: 26.5,
    y2: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.e52a97b86b93c1228cef792dc4d68cab.svg";
export { ForwardRef as ReactComponent };